import { ArpMediaType } from '@arpeggi/shared'
import { useEffect, useState } from 'react'
import { IArpMedia } from '../../arp-registry/ArpMedia'
import ArpRegistry from '../../arp-registry/ArpRegistry'
import { IUser } from '../../arp-registry/User'

export const useArpSampleUsers = (media: IArpMedia) => {
  const [page, setPage] = useState<number>(0)
  const [hasMore, setHasMore] = useState(true)
  const [data, setData] = useState<IUser[]>([])
  const getNextPage = async () => {
    const { media: arpMedia, meta } = await ArpRegistry.search({
      subComponentId: [media.id],
      perPage: 30,
      type: [ArpMediaType.SONG],
      page: page + 1
    })
    setHasMore(meta.currentPage !== meta.lastPage)
    setPage(meta.currentPage)
    const users = [...data, ...arpMedia.map((m) => m.user)]
    const filtered = users.filter(
      (user, index) =>
        index === users.findIndex((found) => found.walletAddress === user.walletAddress) &&
        user.walletAddress !== media.user.walletAddress
    )
    setData(filtered)
  }
  useEffect(() => {
    if (hasMore) getNextPage()
  }, [page, hasMore])
  return { hasMore, data, getNextPage }
}
